import { generateClient, GraphQLResult } from "aws-amplify/api";
import { createImageRoute as createImageRouteGql } from "graphql/mutations";
import { getSignedS3Url } from "graphql/queries";
import { ImageProcessingResult } from "utils/s3/handleToolboxResponse";

/**
 * Given the body and auth token, fires the create image route
 * @author Eric Webb <ewebb@factorearth.com>
 * @param body The post request body
 * @param authToken The auth token
 * @returns The response from the toolbox
 */
async function createImageRoute(file: File): Promise<ImageProcessingResult> {
	interface SignedUrlResponse {
		getSignedS3Url: string;
	}
	const client = generateClient({ authMode: "userPool" });
	const signedUrlResponse = (await client.graphql({
		query: getSignedS3Url,
		authMode: "userPool",
		variables: {
			key: file.name,
		},
	})) as GraphQLResult<SignedUrlResponse>;

	const signedUrl = signedUrlResponse.data.getSignedS3Url;

	await fetch(signedUrl, {
		method: "PUT",
		headers: {
			"Content-Length": `${file.size}`,
		},
		body: file,
	});

	interface CompressionResponse {
		createImageRoute: ImageProcessingResult;
	}
	const compressionResponse = (await client.graphql({
		query: createImageRouteGql,
		authMode: "userPool",
		variables: {
			key: file.name,
		},
	})) as GraphQLResult<CompressionResponse>;
	return compressionResponse.data.createImageRoute;
}

export default createImageRoute;
